import React, { useState } from 'react';

function Testimonial() {
  

  return (
    <section>
      {/* Why Choose EASY ERP Section */}
      <div className="bg-[#0A0F1F] text-white py-40">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">Why Choose <span className="text-yellow-400">NIB ERP</span>?</h2>
          <p className="text-gray-400 mb-12 max-w-2xl mx-auto">
            Discover the advantages that set us apart and make your business operations seamless.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Card 1 */}
            <div className="bg-[#1E2A47] rounded-lg p-6 shadow-md">
              <div className="text-yellow-400 text-4xl mb-4">💡</div>
              <h3 className="text-lg font-bold mb-2">Smart Operations</h3>
              <p className="text-gray-400">
                Automate routine tasks and optimize workflows effortlessly.
              </p>
            </div>
            {/* Card 2 */}
            <div className="bg-[#1E2A47] rounded-lg p-6 shadow-md">
              <div className="text-yellow-400 text-4xl mb-4">📈</div>
              <h3 className="text-lg font-bold mb-2">Seamless Integration</h3>
              <p className="text-gray-400">
                Connect every department with seamless integration.
              </p>
            </div>
            {/* Card 3 */}
            <div className="bg-[#1E2A47] rounded-lg p-6 shadow-md">
              <div className="text-yellow-400 text-4xl mb-4">📊</div>
              <h3 className="text-lg font-bold mb-2">Real-Time Insights</h3>
              <p className="text-gray-400">
                Get accurate, live data for informed decisions.
              </p>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}

export default Testimonial;
